import { Link, useNavigate } from "react-router-dom";
import { LogOut, Settings, QrCode, Users, CalendarDays } from "lucide-react";

export default function AdminHeader() {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("dsa_admin_token");
    nav("/admin");
  };
  return (
    <header
      data-testid="admin-header"
      className="fixed top-0 left-0 right-0 z-30 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/admin/dashboard" className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="" className="h-10 w-10 object-contain" />
          <div className="leading-tight">
            <div className="text-white text-sm tracking-[0.28em]">DAS SIMAO</div>
            <div className="text-[10px] tracking-[0.4em] gold uppercase">Administration</div>
          </div>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <Link to="/admin/dashboard" data-testid="admin-nav-dashboard" className="text-gray-300 hover:text-white">
            Réservations
          </Link>
          <Link to="/admin/planning" data-testid="admin-nav-planning" className="text-gray-300 hover:text-white inline-flex items-center gap-1">
            <CalendarDays size={14} /> Planning
          </Link>
          <Link to="/admin/qr-codes" data-testid="admin-nav-qr" className="text-gray-300 hover:text-white inline-flex items-center gap-1">
            <QrCode size={14} /> QR Codes
          </Link>
          <Link to="/admin/waitlist" data-testid="admin-nav-waitlist" className="text-gray-300 hover:text-white inline-flex items-center gap-1">
            <Users size={14} /> Waitlist
          </Link>
          <Link to="/admin/settings" data-testid="admin-nav-settings" className="text-gray-300 hover:text-white inline-flex items-center gap-1">
            <Settings size={14} /> Paramètres
          </Link>
          <button
            data-testid="admin-btn-logout"
            onClick={logout}
            className="text-gray-400 hover:text-red-400 inline-flex items-center gap-1"
          >
            <LogOut size={14} /> Déconnexion
          </button>
        </nav>
      </div>
    </header>
  );
}
